import { computeForecast, type ForecastInputs, type GoalNumbers, type Stretch } from './forecast'

// The planner's freedom suggestion. It only reads the forecast, so it lives
// apart from forecast.ts, which mirrors the Go planner line for line.
export interface DropDay {
  day: number
  take_home_pence: number
}

// dropDay is the freedom suggestion for a week already over its goal: the
// one working day she could stop working and still reach the goal, keeping
// the most take-home, with a later day winning a tie (a Saturday before a
// Monday). Null when the week is short of its goal, has one working day, or
// no single day can go.
export function dropDay(week: Stretch[], inputs: ForecastInputs, goal: GoalNumbers): DropDay | null {
  const target = goal.take_home_target_pence
  if (computeForecast(week, inputs, goal).take_home_pence < target) return null
  const days = [...new Set(week.map((s) => s.weekday))]
  if (days.length < 2) return null
  let best: DropDay | null = null
  for (const day of days) {
    const takeHome = computeForecast(week.filter((s) => s.weekday !== day), inputs, goal).take_home_pence
    if (takeHome < target) continue
    if (!best || takeHome > best.take_home_pence || (takeHome === best.take_home_pence && day > best.day)) {
      best = { day, take_home_pence: takeHome }
    }
  }
  return best
}
